import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.local_bill_category;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  }));

export const createLocalBillCategory = async (billCategoryData: any) => {
    return await api.post('/CreateLocalBillCategory', billCategoryData, {
    });
}

export const getLocalBillCategoryByLocalId = async(localId: number) =>{
    return await api.get(`/GetLocalBillCategoryByLocalId/${localId}`, {
    });
}

export const deleteLocalBillCategory = async (localBillCategoryId: number) => {
    return await api.delete(`/DeleteLocalBillCategoryById/${localBillCategoryId}`, {
    });
}


export const updateLocalBillCategoryById = async (localBillCategoryId: number, billCategoryData: any) => {
  return await api.put(`/UpdateLocalBillCategoryById/${localBillCategoryId}`, billCategoryData, {});
}

export const getLocalBillCategoryById = async (localBillCategoryId: number) => {
  return await api.get(`/GetLocalBillCategoryById/${localBillCategoryId}`, {});
}